export const SET_TP_CONTACT_FILTERS = 'SET_TP_CONTACT_FILTERS';
export const setTPContactFilters = (filterData: any) => ({
  type: SET_TP_CONTACT_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const tpContactFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_TP_CONTACT_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default tpContactFilterReducer;
